import './OnboardingPipeline.css';

export default function OnboardingPipeline() {

  return (
    <section className="onboarding-section">
      <div className="onboarding-header-split">
        <h2>Go live in 3 minutes. No engineering required.</h2>
        <p>No technical setup marathon. Add your site, verify answers, and launch confidently in minutes.</p>
      </div>

      <div className="onboarding-grid">

        {/* Card 1 */}
        <div className="ob-card-container">
          <div className="ob-card">
            <div className="ob-visual ob-visual-1">
              {/* Sitemap Tree Visualization */}
              <div className="ob-sitemap">
                {/* Root Node */}
                <div className="sm-root">
                  <svg className="sm-lock" viewBox="0 0 16 16" fill="none" width="10" height="10">
                    <path d="M4 7V5a4 4 0 1 1 8 0v2" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round"/>
                    <rect x="3" y="7" width="10" height="7" rx="1.5" fill="#10b981"/>
                  </svg>
                  <span>your-startup.com</span>
                </div>

                {/* Connector Lines (SVG) */}
                <svg className="sm-lines" viewBox="0 0 280 40" preserveAspectRatio="none">
                  <path d="M140 0 L40 40"  stroke="#e2e8f0" strokeWidth="1.5" fill="none"/>
                  <path d="M140 0 L105 40" stroke="#e2e8f0" strokeWidth="1.5" fill="none"/>
                  <path d="M140 0 L140 40" stroke="#e2e8f0" strokeWidth="1.5" fill="none"/>
                  <path d="M140 0 L175 40" stroke="#e2e8f0" strokeWidth="1.5" fill="none"/>
                  <path d="M140 0 L240 40" stroke="#e2e8f0" strokeWidth="1.5" fill="none"/>
                </svg>

                {/* Branch Nodes — Row 1 */}
                <div className="sm-row">
                  <div className="sm-node sm-active">/pricing</div>
                  <div className="sm-node">/about</div>
                  <div className="sm-node">/docs</div>
                  <div className="sm-node">/blog</div>
                  <div className="sm-node">/careers</div>
                </div>

                {/* Second Level Connectors */}
                <svg className="sm-lines sm-lines-2" viewBox="0 0 280 28" preserveAspectRatio="none">
                  <path d="M40 0 L20 28"   stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                  <path d="M40 0 L60 28"   stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                  <path d="M140 0 L120 28" stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                  <path d="M140 0 L160 28" stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                  <path d="M240 0 L220 28" stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                  <path d="M240 0 L260 28" stroke="#e2e8f0" strokeWidth="1" fill="none"/>
                </svg>

                {/* Leaf Nodes — Row 2 */}
                <div className="sm-row sm-row-leaves">
                  <div className="sm-leaf">/plans</div>
                  <div className="sm-leaf">/faq</div>
                  <div className="sm-spacer"></div>
                  <div className="sm-leaf">/api</div>
                  <div className="sm-leaf">/sdk</div>
                  <div className="sm-spacer"></div>
                  <div className="sm-leaf">/jobs</div>
                  <div className="sm-leaf">/team</div>
                </div>

                {/* Scan pulse indicator */}
                <div className="sm-scan-pulse"></div>
              </div>

              <div className="ob-scanning-text">
                <span className="ob-dot pulse"></span> Scanning 342 pages...
              </div>
            </div>
            <div className="ob-card-header">
              <h3>Ingest Domain</h3>
              <p>Paste your website URL or upload your internal documentation. We scrape everything instantly.</p>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="ob-card-container">
          <div className="ob-card">
            <div className="ob-visual ob-visual-2">
              {/* Volumetric Debris: Scattered file cards showing volume of sources */}
              <div className="ob-debris" aria-hidden="true">
                <div className="debris-file file-1">
                  <div className="dfile-icon dfile-pdf">PDF</div>
                  <span>return-policy.pdf</span>
                </div>
                <div className="debris-file file-2">
                  <div className="dfile-icon dfile-notion">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png" alt="" />
                  </div>
                  <span>Product Wiki</span>
                </div>
                <div className="debris-file file-3">
                  <div className="dfile-icon dfile-txt">TXT</div>
                  <span>april_offers.txt</span>
                </div>
                <div className="debris-file file-4">
                  <div className="dfile-icon dfile-web">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /></svg>
                  </div>
                  <span>acme.com/products</span>
                </div>
                <div className="debris-file file-5">
                  <div className="dfile-icon dfile-csv">CSV</div>
                  <span>customers.csv</span>
                </div>
                <div className="debris-file file-6">
                  <div className="dfile-icon dfile-md">MD</div>
                  <span>README.md</span>
                </div>
                <div className="debris-file file-7">
                  <div className="dfile-icon dfile-doc">DOC</div>
                  <span>onboarding.docx</span>
                </div>
                <div className="debris-file file-8">
                  <div className="dfile-icon dfile-json">{'{}'}</div>
                  <span>config.json</span>
                </div>
              </div>
            </div>
            <div className="ob-card-header">
              <h3>Auto-Train</h3>
              <p>Our infrastructure chunk-encodes your entire knowledge base into a vector database in seconds.</p>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="ob-card-container">
          <div className="ob-card ob-card-hero">
            <div className="ob-visual ob-visual-3">
              {/* Mini Website with Live Chat Widget */}
              <div className="ob-site-preview">
                {/* Mini Browser Chrome */}
                <div className="sp-chrome">
                  <div className="sp-dots"><span></span><span></span><span></span></div>
                  <div className="sp-url-bar">acme.com</div>
                  <div className="sp-live-badge">
                    <span className="sp-live-dot"></span> LIVE
                  </div>
                </div>

                {/* Skeleton website body */}
                <div className="sp-body">
                  <div className="sp-nav">
                    <div className="sp-nav-logo"></div>
                    <div className="sp-nav-links"><span></span><span></span><span></span></div>
                  </div>
                  <div className="sp-hero-block">
                    <div className="sp-hero-line w-60"></div>
                    <div className="sp-hero-line w-40"></div>
                    <div className="sp-hero-btn"></div>
                  </div>
                  <div className="sp-content-rows">
                    <div className="sp-row"></div>
                    <div className="sp-row short"></div>
                    <div className="sp-row"></div>
                  </div>

                  {/* Floating query bubbles across the site */}
                  <div className="sp-queries" aria-hidden="true">
                    <div className="sp-query q-1">Where is my order?</div>
                    <div className="sp-query q-2">Pricing details?</div>
                    <div className="sp-query q-3">How do I integrate?</div>
                    <div className="sp-query q-4">Refund policy?</div>
                    <div className="sp-query q-5">Talk to sales</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ob-card-header">
              <h3>Deploy Agent</h3>
              <p>Paste this single snippet into your HTML <code className="ob-inline-code">&lt;head&gt;</code>. You're fully live.</p>
            </div>
          </div>
        </div>

      </div>

    </section>
  );
}
